import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../css.css';

const EmailVerification = () => {
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // URL에서 토큰 추출
        const urlParams = new URLSearchParams(location.search);
        const verificationToken = urlParams.get('token');
        
        if (verificationToken) {
            verifyEmail(verificationToken);
        } else {
            setMessage('유효하지 않은 인증 링크입니다.');
            setIsLoading(false);
        }
    }, [location]);

    const verifyEmail = async (verificationToken) => {
        try {
            const response = await fetch('/api/auth/verify-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: verificationToken }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('이메일 인증이 완료되었습니다! 이제 로그인할 수 있습니다.');
                setIsSuccess(true);
            } else {
                setMessage(data.message || '이메일 인증에 실패했습니다.');
                setIsSuccess(false);
            }
        } catch (error) {
            console.error('이메일 인증 오류:', error);
            setMessage('이메일 인증 중 오류가 발생했습니다.');
            setIsSuccess(false);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToHome = () => {
        navigate('/');
    };

    const handleLogin = () => {
        navigate('/?login=true');
    };

    return (
        <div className="email-verification-container">
            <div className="email-verification-form">
                <h2>이메일 인증</h2>
                
                {isLoading ? (
                    <div className="loading-section">
                        <div className="loading-spinner"></div>
                        <p>이메일 인증을 처리하고 있습니다...</p>
                    </div>
                ) : (
                    <div className="verification-result">
                        <div className={`result-icon ${isSuccess ? 'success' : 'error'}`}>
                            {isSuccess ? '✅' : '❌'}
                        </div>
                        
                        <p className={`result-message ${isSuccess ? 'success-message' : 'error-message'}`}>
                            {message}
                        </p>
                        
                        <div className="verification-actions">
                            {isSuccess ? (
                                <button 
                                    onClick={handleLogin}
                                    className="login-button"
                                >
                                    로그인하기
                                </button>
                            ) : (
                                <button 
                                    onClick={handleBackToHome}
                                    className="back-button"
                                >
                                    홈으로 돌아가기
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmailVerification;
